import { api } from '../client'
import type { RequestOptions } from '../client'
import type { TenderFilter, TenderFilterInput, TenderFilterRunResult } from './types'

export const tenderFiltersHttpApi = {
  list: (options?: RequestOptions): Promise<TenderFilter[]> =>
    api.get<TenderFilter[]>('/filters', options),

  get: (id: number, options?: RequestOptions): Promise<TenderFilter> =>
    api.get<TenderFilter>(`/filters/${id}`, options),

  create: (input: TenderFilterInput, options?: RequestOptions): Promise<TenderFilter> =>
    api.post<TenderFilter>('/filters', input, options),

  update: (id: number, input: TenderFilterInput, options?: RequestOptions): Promise<TenderFilter> =>
    api.put<TenderFilter>(`/filters/${id}`, input, options),

  remove: (id: number, options?: RequestOptions): Promise<void> =>
    api.del<void>(`/filters/${id}`, options),

  // Admin-only on the backend (AuthMiddleware default-deny): edits the one
  // company-default filter (OGCS Default) in place — name, CPV codes and
  // platforms — without ever changing which filter is default.
  updateCompanyDefault: (
    input: TenderFilterInput,
    options?: RequestOptions,
  ): Promise<TenderFilter> => api.put<TenderFilter>('/company-default-filter', input, options),

  run: (id: number, options?: RequestOptions): Promise<TenderFilterRunResult> =>
    api.post<TenderFilterRunResult>(`/filters/${id}/run`, undefined, options),
}
